import type { ModuleMeta } from '@/delivery-type-plugin/core/types';
import { SKU_RESOURCE_MODULES_FIELD } from '@/delivery-type-plugin/platform/scene-layout/types';

/** 按物理路径删除嵌套字段（SKU preset 裁剪用） */
export function unsetFormPath(target: Record<string, unknown>, path: string): void {
  const segments = path.split('.').filter(Boolean);
  if (!segments.length) return;
  if (segments.length === 1) {
    delete target[segments[0]];
    return;
  }
  let current: unknown = target;
  for (let i = 0; i < segments.length - 1; i += 1) {
    if (current == null || typeof current !== 'object' || Array.isArray(current)) return;
    current = (current as Record<string, unknown>)[segments[i]];
  }
  if (current == null || typeof current !== 'object' || Array.isArray(current)) return;
  delete (current as Record<string, unknown>)[segments[segments.length - 1]];
}

/**
 * 未勾选模块的字段不应进入 SKU preset / 提交快照。
 * 有勾选态时：仅保留 `skuResourceModules[key] === true` 的模块字段；无勾选态（空对象 / 缺省）原样返回。
 */
export function omitUncheckedSkuModuleFormFields<TField extends string>(
  values: Record<string, unknown>,
  modules: readonly ModuleMeta<TField>[],
): Record<string, unknown> {
  const skuModules = values[SKU_RESOURCE_MODULES_FIELD] as Record<string, boolean> | undefined;
  if (!skuModules || typeof skuModules !== 'object' || Object.keys(skuModules).length === 0) {
    return values;
  }

  const next: Record<string, unknown> = { ...values };
  for (const mod of modules) {
    if (skuModules[mod.key] === true) continue;
    const paths = mod.resetFieldPaths;
    if (!paths?.length) continue;
    for (const path of paths) {
      unsetFormPath(next, path);
    }
  }
  return next;
}
